import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Eye, EyeOff, Copy } from "lucide-react";
import { toast } from "react-toastify";

function RenderShowPasswordModal(props) {
  const [showPassword, setShowPassword] = useState(false);

  // Extract password from "Password is : 1234567" format
  const passwordValue = props?.passwordValue?.includes("Password is :")
    ? props.passwordValue.replace("Password is :", "").trim()
    : props?.passwordValue && props.passwordValue !== "Actual Password is not saved for this user"
    ? props.passwordValue
    : "";

  const userId = props.userId;

  const handleClose = () => {
    props.setShow(false);
    if (props.setConfirmShowPassword) {
      props.setConfirmShowPassword(false);
    }
    setShowPassword(false);
  };

  const handleCopyPassword = () => {
    if (passwordValue && passwordValue !== "Actual Password is not saved for this user") {
      navigator.clipboard.writeText(passwordValue);
      toast.success("Password copied to clipboard");
    }
  };

  return (
    <>
      <style>
        {`
          .user-password-modal .modal-content {
            border-radius: 14px !important;
            overflow: hidden;
            box-shadow: 0 25px 60px rgba(0,0,0,0.25) !important;
          }
          .user-password-modal .modal-header {
            background: linear-gradient(135deg, #1e2a55, #2f4b8f) !important;
            color: white !important;
            border-bottom: none !important;
            border-radius: 14px 14px 0 0 !important;
            padding: 18px 24px !important;
          }
          .user-password-modal .modal-title {
            color: white !important;
            font-size: 20px !important;
            font-weight: 600 !important;
            letter-spacing: 0.3px !important;
          }
          .user-password-modal .btn-close {
            filter: brightness(0) invert(1) !important;
            opacity: 0.8 !important;
            font-size: 20px !important;
            transition: opacity 0.2s !important;
          }
          .user-password-modal .btn-close:hover {
            opacity: 1 !important;
          }
          .user-password-modal .modal-body {
            padding: 24px !important;
          }
        `}
      </style>
      <Modal 
        show={props.show} 
        onHide={handleClose} 
        centered
        dialogClassName="user-password-modal"
      >
        <Modal.Header 
          style={{ 
            position: "relative"
          }}
        >
          <Modal.Title style={{ color: "white", fontSize: "20px", fontWeight: "600", letterSpacing: "0.3px", margin: 0 }}>
            User Password
          </Modal.Title>
          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={handleClose}
            aria-label="Close"
          />
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "white" }}>
        <p style={{ marginBottom: "1rem", color: "#6c757d", fontSize: "0.9rem" }}>
          Manage the user's password securely.
        </p>
        <Form.Group className="mb-0">
          <Form.Label style={{ fontWeight: "500", marginBottom: "0.5rem" }}>
            Password
          </Form.Label>
          <div style={{ position: "relative" }}>
            <Form.Control
              type={showPassword ? "text" : "password"}
              value={passwordValue}
              readOnly
              style={{
                paddingRight: "80px",
                backgroundColor: "#f8f9fa",
                border: "1px solid #dee2e6"
              }}
            />
            <div style={{ 
              position: "absolute", 
              right: "8px", 
              top: "50%", 
              transform: "translateY(-50%)",
              display: "flex",
              gap: "4px"
            }}>
              <Button
                variant="link"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  padding: "4px 8px",
                  minWidth: "auto",
                  color: "#6c757d",
                  textDecoration: "none"
                }}
                title={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? (
                  <EyeOff size={18} />
                ) : (
                  <Eye size={18} />
                )}
              </Button>
              {passwordValue && passwordValue !== "Actual Password is not saved for this user" && (
                <Button
                  variant="link"
                  onClick={handleCopyPassword}
                  style={{
                    padding: "4px 8px",
                    minWidth: "auto",
                    color: "#6c757d",
                    textDecoration: "none"
                  }}
                  title="Copy password"
                >
                  <Copy size={18} />
                </Button>
              )}
            </div>
          </div>
        </Form.Group>
      </Modal.Body>
      <div style={{
        backgroundColor: "white",
        borderTop: "1px solid #e5e7eb",
        padding: "16px 24px",
        marginTop: "0",
        borderRadius: "0 0 14px 14px"
      }}></div>
      </Modal>
    </>
  );
}

export default RenderShowPasswordModal;
